import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_Y } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { checkCtrlPressed } from '@/helpers';
import { redoStepThunk } from '@/actions';

// NOT USED: there is a problem with German keyboard layout (cmd + y = 'Undo')
export default () => {
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      removeListener();
    } else {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      removeListener();
    };
  });

  const removeListener = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = event => {
    const isCtrlPressed = checkCtrlPressed(event);

    if (isCtrlPressed && event.code === KEY_Y) {
      event.preventDefault();
      dispatch(redoStepThunk());
    }
  };
};
